module.exports = __webpack_public_path__ + "static/media/hand-holding-water.e8e18a3f.svg";